export const getFrequencyMap = (values) => values.reduce((counts, value) => {
    counts.set(value, (counts.get(value) ?? 0) + 1);
    return counts;
}, new Map());
//# sourceMappingURL=getFrequencyMap.js.map